<template>
    <div
        :id="id"
        class="stepper-wrapper"
    >
        <template
            v-for="(step, index) in stepsArray"
            :key="step"
        >
            <div
                v-if="index > 0"
                class="connector left"
                :class="{ completed: step <= Number(currentStep) }"
            />
            <div
                class="step"
                :class="{
                    active: step === Number(currentStep),
                    completed: step < Number(currentStep)
                }"
            >
                {{ step }}
            </div>
            <div
                v-if="index < stepsArray.length - 1"
                class="connector right"
                :class="{ completed: step < Number(currentStep) }"
            />
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    currentStep: Number,
    steps: Number,
})

const stepsArray = computed(() => {
    return Array.from({ length: props.steps }, (_, i) => i + 1)
})
</script>

<style lang="sass" scoped>
@import './Stepper.sass'
</style>
